// Shared acronym-aware role label formatter — mirrors the backend
// services/invite_delivery.format_role_label so the UI never shows raw role
// values like "bcm_manager". Display-only; no permission/role logic here.
const ROLE_LABEL_OVERRIDES = {
  admin: "Website Admin",
  bcm_manager: "BCM Manager",
  it_drp_manager: "IT-DRP Manager",
  it_function_manager: "IT Function Manager",
  it_function_contributor: "IT Function Contributor",
  process_manager: "Process Manager",
  process_contributor: "Process Contributor",
  app_manager: "Application Manager",
  app_contributor: "Application Contributor",
  department_head: "Department Head",
  executive_sponsor: "Executive Sponsor",
  viewer: "External Auditor / Viewer",
  end_user: "End User",
  business_user: "Business User",
};

export function formatRoleLabel(role) {
  if (!role) return "Team Member";
  if (ROLE_LABEL_OVERRIDES[role]) return ROLE_LABEL_OVERRIDES[role];
  return role
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

// Prefer a stored, invite-time role_label (e.g. "Deputy BCM Manager") and fall
// back to deriving the label from the role value with the shared formatter.
export function resolveRoleLabel(user) {
  if (!user) return "Team Member";
  return user.role_label || formatRoleLabel(user.role);
}
